// extracted by mini-css-extract-plugin
export default {"carousel":"ITAJumboLocation_carousel__am6Sp"};